import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";

import "../excalidraw-app/sentry";

import ExcalidrawApp from "./App";

window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;

// Handle Dropbox OAuth callback
const urlParams = new URLSearchParams(window.location.search);
const dropboxCode = urlParams.get("code");
if (dropboxCode) {
  // Send code to opener window
  if (window.opener) {
    window.opener.postMessage(
      { type: "dropbox-auth", code: dropboxCode },
      window.location.origin,
    );
    window.close();
  } else {
    // If not opened as popup, redirect to clean URL and handle auth
    window.opener = window;
    window.postMessage(
      { type: "dropbox-auth", code: dropboxCode },
      window.location.origin,
    );
    // Clean URL
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}

const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();
root.render(
  <StrictMode>
    <ExcalidrawApp />
  </StrictMode>,
);
